/* tslint:disable */
/* eslint-disable */
/**
 * Funnels API
 * API for managing funnels
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { IdLabel } from './IdLabel';
import {
    IdLabelFromJSON,
    IdLabelFromJSONTyped,
    IdLabelToJSON,
    IdLabelToJSONTyped,
} from './IdLabel';

/**
 * Item de la liste admin des tunnels.
 * @export
 * @interface TunnelAdminListItem
 */
export interface TunnelAdminListItem {
    /**
     * 
     * @type {string}
     * @memberof TunnelAdminListItem
     */
    id: string;
    /**
     * Code (identifiant) du tunnel
     * @type {string}
     * @memberof TunnelAdminListItem
     */
    code: string;
    /**
     * Désignation
     * @type {string}
     * @memberof TunnelAdminListItem
     */
    label: string;
    /**
     * 
     * @type {string}
     * @memberof TunnelAdminListItem
     */
    productId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TunnelAdminListItem
     */
    productCode?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TunnelAdminListItem
     */
    productLabel?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TunnelAdminListItem
     */
    branchName?: string | null;
    /**
     * Valeurs de TypeTunnel : 1 = Individuel, 2 = Collectif
     * @type {number}
     * @memberof TunnelAdminListItem
     */
    tunnelType: number;
    /**
     * 
     * @type {number}
     * @memberof TunnelAdminListItem
     */
    quotesCount: number;
    /**
     * Contrats En cours
     * @type {number}
     * @memberof TunnelAdminListItem
     */
    activeContractsCount: number;
    /**
     * Distributeur / représentant du tunnel (décorrélé du prélèvement)
     * @type {string}
     * @memberof TunnelAdminListItem
     */
    ownerId?: string | null;
    /**
     * Désignation du distributeur (facette owners / filtre owners / tri owner)
     * @type {string}
     * @memberof TunnelAdminListItem
     */
    ownerName?: string | null;
    /**
     * 
     * @type {Array<IdLabel>}
     * @memberof TunnelAdminListItem
     */
    plateformes?: Array<IdLabel>;
    /**
     * 
     * @type {boolean}
     * @memberof TunnelAdminListItem
     */
    isActive: boolean;
    /**
     * 
     * @type {Date}
     * @memberof TunnelAdminListItem
     */
    creationDate: Date;
    /**
     * 
     * @type {Date}
     * @memberof TunnelAdminListItem
     */
    lastModificationDate?: Date | null;
}

/**
 * Check if a given object implements the TunnelAdminListItem interface.
 */
export function instanceOfTunnelAdminListItem(value: object): value is TunnelAdminListItem {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('code' in value) || value['code'] === undefined) return false;
    if (!('label' in value) || value['label'] === undefined) return false;
    if (!('tunnelType' in value) || value['tunnelType'] === undefined) return false;
    if (!('quotesCount' in value) || value['quotesCount'] === undefined) return false;
    if (!('activeContractsCount' in value) || value['activeContractsCount'] === undefined) return false;
    if (!('isActive' in value) || value['isActive'] === undefined) return false;
    if (!('creationDate' in value) || value['creationDate'] === undefined) return false;
    return true;
}

export function TunnelAdminListItemFromJSON(json: any): TunnelAdminListItem {
    return TunnelAdminListItemFromJSONTyped(json, false);
}

export function TunnelAdminListItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): TunnelAdminListItem {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'code': json['code'],
        'label': json['label'],
        'productId': json['productId'] == null ? undefined : json['productId'],
        'productCode': json['productCode'] == null ? undefined : json['productCode'],
        'productLabel': json['productLabel'] == null ? undefined : json['productLabel'],
        'branchName': json['branchName'] == null ? undefined : json['branchName'],
        'tunnelType': json['tunnelType'],
        'quotesCount': json['quotesCount'],
        'activeContractsCount': json['activeContractsCount'],
        'ownerId': json['ownerId'] == null ? undefined : json['ownerId'],
        'ownerName': json['ownerName'] == null ? undefined : json['ownerName'],
        'plateformes': json['plateformes'] == null ? undefined : ((json['plateformes'] as Array<any>).map(IdLabelFromJSON)),
        'isActive': json['isActive'],
        'creationDate': (new Date(json['creationDate'])),
        'lastModificationDate': json['lastModificationDate'] == null ? undefined : (new Date(json['lastModificationDate'])),
    };
}

export function TunnelAdminListItemToJSON(json: any): TunnelAdminListItem {
    return TunnelAdminListItemToJSONTyped(json, false);
}

export function TunnelAdminListItemToJSONTyped(value?: TunnelAdminListItem | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'code': value['code'],
        'label': value['label'],
        'productId': value['productId'],
        'productCode': value['productCode'],
        'productLabel': value['productLabel'],
        'branchName': value['branchName'],
        'tunnelType': value['tunnelType'],
        'quotesCount': value['quotesCount'],
        'activeContractsCount': value['activeContractsCount'],
        'ownerId': value['ownerId'],
        'ownerName': value['ownerName'],
        'plateformes': value['plateformes'] == null ? undefined : ((value['plateformes'] as Array<any>).map(IdLabelToJSON)),
        'isActive': value['isActive'],
        'creationDate': ((value['creationDate']).toISOString()),
        'lastModificationDate': value['lastModificationDate'] == null ? undefined : ((value['lastModificationDate'] as any).toISOString()),
    };
}

